"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.sort.js");

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _vuex = require("vuex");

var _markets = require("@/model/markets/markets");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _settings = require("@/model/settings");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  mixins: [_commonMixin.default],
  components: {
    NoData: _NoData.default
  },
  props: {
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableDataComputed: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  // watch:{
  //   tableData:{
  //     handler:function(){
  //       this.$nextTick(function (){
  //         this.$refs.marketTable.setCurrentRow(this.tableData[0])
  //       })
  //     }
  //   }
  // },
  data: function data() {
    return {
      ws: null,
      tradePair: [],
      tradePairArray: [],
      tableData: [],
      // tableDataComputed: [],
      selectSymbol: "",
      symbol: "",
      coinInfoMap: {},
      CoinItemIdMap: {},
      tabList: [{
        value: "self",
        label: "自选"
      }, {
        value: "usdt",
        label: "U本位合约"
      } // {
      //   value: "btc",
      //   label: "BTC",
      // },
      ],
      currIndex: "usdt",
      selfOptionsList: []
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var tempSymbol;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getExchangeItemId();

            case 2:
              _context.next = 4;
              return _this.getStaticTableInfo(49);

            case 4:
              tempSymbol = _this.$route.params.symbol || "btcusdt";
              _this.symbol = tempSymbol;

              _this.getOptionList(); // const [coinFrom, coinTo] = tempSymbol.split("_");
              // if (coinTo.toLowerCase() == "btc") {
              //   this.currIndex = "btc";
              // } else {
              //   this.currIndex = "usdt";
              // }


            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {// this.$refs.marketTable.setCurrentRow(this.tableData[0],true)
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    getExchangeItemId: function getExchangeItemId() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(13);

              case 2:
                _yield$apiGetStaticTa = _context2.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this2.CoinItemIdMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getStaticTableInfo: function getStaticTableInfo(sv_id) {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa2, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(sv_id);

              case 2:
                _yield$apiGetStaticTa2 = _context3.sent;
                status = _yield$apiGetStaticTa2.status;
                data = _yield$apiGetStaticTa2.data;

                if (status == 200) {
                  _this3.coinInfoMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;
      var trade_pair = this.symbol.toLowerCase();

      if (row.symbol.toLowerCase() == trade_pair) {
        return "warning-row";
      }

      return "";
    },
    getRowKeys: function getRowKeys(row) {
      return row.symbol_id;
    },
    addOption: function addOption(row, type) {
      var _this4 = this;

      if (this.userInfo) {
        var params = {
          symbol_id: row.symbol_id,
          option: type,
          swap_type: 2
        };
        (0, _markets.apiAddOption)(params).then(function (res) {
          if (res.status == 200) {
            _this4.$emit("onAddOption");

            _this4.getOptionList();

            _this4.$message({
              message: params.option == 1 ? _this4.translateTitle("\u6DFB\u52A0\u81EA\u9009\u6210\u529F") : _this4.translateTitle("\u5220\u9664\u81EA\u9009\u6210\u529F"),
              type: params.option == 1 ? "success" : "success"
            });
          }
        });
      } else {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      }
    },
    onSymbolChange: function onSymbolChange(item, column) {
      if (column != undefined && column.label == "币种") {
        return;
      }

      var trade_pair = item.name.replace("_", "").toLowerCase();
      this.symbol = trade_pair;
      this.$router.push(this.routeSplicing(this.language, "contract-exchange/".concat(trade_pair)));
      this.$emit("on-symbol-change", item);
    },
    onAreaChange: function onAreaChange(item) {
      this.currIndex = item.value;
    },
    compareOrderBy: function compareOrderBy(property) {
      return function (a, b) {
        if (a[property] < b[property]) {
          return -1;
        } else if (a[property] == b[property]) {
          return 0;
        } else {
          return 1;
        }
      };
    },
    getOptionList: function getOptionList() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$Account$getUse, userInfo;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Account.getUserInfo();

              case 2:
                _yield$Account$getUse = _context4.sent;
                userInfo = _yield$Account$getUse.userInfo;

                if (userInfo) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                (0, _markets.apiGetOptionList)().then(function (res) {
                  if (res.status == 200) {
                    if (JSON.stringify(res.data) != "{}" && res.data.digital) {
                      _this5.selfOptionsList = res.data.digital;
                    }
                  }
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language"
  })), {}, {
    tableLoading: function tableLoading() {
      var val = 1;

      if (this.marketList.length > 0) {
        val = 0;
      } else {
        val = 1;
      }

      return val;
    },
    //FIXME 交易对搜索输入框输入ETH 永续搜索不出来内容,原因：使用元素的symbol进行对比，应用使用symbol_name，但国际化时？
    showList: function showList() {
      var _this6 = this;

      var tempMarket = [];
      this.marketList.forEach(function (item) {
        for (var key in _this6.coinInfoMap) {
          if (item.symbol_id == key && _this6.coinInfoMap[key].status == 1) {
            tempMarket.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), _this6.coinInfoMap[key]));
          }
        }
      });
      tempMarket.forEach(function (item) {
        for (var key in _this6.CoinItemIdMap) {
          if (item.change_item_id == key) {
            item.coin_name = _this6.CoinItemIdMap[item.change_item_id].item_name.toUpperCase();
          }
        }
      });
      var tempArr = [];
      tempArr = tempMarket.filter(function (ele) {
        if (_this6.currIndex == "self") {
          if (_this6.selectSymbol != "") {
            if (ele.symbol_name.toLowerCase().indexOf(_this6.selectSymbol.trim().toLowerCase()) != -1) {
              return true;
            }
          } else {
            return _this6.selfOptionsList.indexOf(ele.symbol_id.toString()) > -1;
          }
        } else {
          if (_this6.selectSymbol != "") {
            if (ele.symbol_name.toLowerCase().indexOf(_this6.selectSymbol.trim().toLowerCase()) != -1) {
              return true;
            }
          } else {
            return ele;
          }
        }
      });
      tempArr.sort(this.compareOrderBy("order_by"));
      var tempArr2 = [];
      tempArr.forEach(function (ele) {
        tempArr2.push(ele.order_by + " -- " + ele.name);
      });
      return tempArr;
    }
  })
};
exports.default = _default2;